import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';

const apkDownloadUrl =
  'https://drive.google.com/uc?export=download&id=1eYpQVDqm3u9MHW8doR6pAGktj7wZh12C'; // Replace with real file ID

const QrCodeModal: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button onClick={() => setIsOpen(true)} style={styles.button}>
        📱 Download App via QR Code
      </button>

      {isOpen && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <h2 style={styles.title}>Scan to Download</h2>
            <p style={styles.subtitle}>Use your phone's camera or scanner app</p>
            <div style={styles.qrContainer}>
              <QRCodeSVG value={apkDownloadUrl} size={200} />
            </div>
            <button onClick={() => setIsOpen(false)} style={styles.closeButton}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default QrCodeModal;

// ----------------------
// Styles
// ----------------------

const styles: { [key: string]: React.CSSProperties } = {
  button: {
    padding: '12px 2px',
    fontSize: '15px',
    fontWeight: 600,
    backgroundColor: '#4CAF50',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  },

  overlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },

  modal: {
    backgroundColor: '#fff',
    padding: '32px 24px',
    borderRadius: '10px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
    maxWidth: '360px',
    width: '90%',
    textAlign: 'center',
    animation: 'fadeIn 0.3s ease-in-out',
  },

  title: {
    fontSize: '20px',
    marginBottom: '8px',
  },

  subtitle: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '20px',
  },

  qrContainer: {
    marginBottom: '20px',
    display: 'flex',
    justifyContent: 'center',
  },

  closeButton: {
    padding: '10px 20px',
    backgroundColor: '#d9534f',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    cursor: 'pointer',
  },
};
